import api from './api';

export const courseService = {
  // Get all courses
  getAllCourses: async () => {
    const response = await api.get('/courses');
    return response.data;
  },
  
  // Get course by ID
  getCourseById: async (courseId) => {
    const response = await api.get(`/courses/${courseId}`);
    return response.data;
  },
  
  // Get course syllabus
  getCourseSyllabus: async (courseId) => {
    const response = await api.get(`/courses/${courseId}/syllabus`);
    return response.data;
  },
  
  // Get lesson by ID
  getLessonById: async (lessonId) => {
    const response = await api.get(`/lessons/${lessonId}`);
    return response.data;
  },
  
  // Get next lesson
  getNextLesson: async (lessonId) => {
    const response = await api.get(`/lessons/${lessonId}/next`);
    return response.data;
  },
  
  // Get previous lesson
  getPreviousLesson: async (lessonId) => {
    const response = await api.get(`/lessons/${lessonId}/previous`);
    return response.data;
  },
  
  // Get course projects
  getCourseProjects: async (courseId) => {
    const response = await api.get(`/courses/${courseId}/projects`);
    return response.data;
  },
};

export default courseService;




